export default "__VITE_ASSET__aMUORojV__"